import { STORE_KEYS } from "@/shared/consts";

export const getDefaultCamera = (): string => {
  const pathname = window.location.pathname;
  const storeKeyMatch = pathname.match(/\/stores\/([^/]+)/);
  const storeKey = storeKeyMatch ? storeKeyMatch[1] : null;

  return storeKey === STORE_KEYS.GOKTURK_POD ? "163" : "136";
};
